import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
	fetchGeneralRankings,
	getRankingsByPeriod,
	getRankingsTournaments,
} from '../../services/api';
import {
	rankingsByPeriodFailure,
	rankingsByPeriodRequest,
	rankingsByPeriodSuccess,
	rankingsFailure,
	rankingsRequest,
	rankingsSuccess,
	rankingsTournamentsFailure,
	rankingsTournamentsRequest,
	rankingsTournamentsSuccess,
} from './rankingsActions';

function normalizeRankData(raw: any[]): any[] {
	return (raw || []).map(r => ({
		id: r.playerId,
		username: r.username,
		level: r.level ?? r.rank,
		totalChips: r.totalChips ?? r.chipsWon ?? r.award ?? 0,
		exp: r.exp ?? 0,
		avatarFileId: r.avatarFileId ?? null,
		isVip: Boolean(r.isVip),
		endAt: r?.stats?.end_at ?? null,
		now: r?.stats?.now ?? null,
		weeklyTournamentPoints: r.weeklyTournamentPoints ?? 0,
	}));
}

function* rankingsWorker(action: ReturnType<typeof rankingsRequest>) {
	try {
		const res: AxiosResponse = yield call(fetchGeneralRankings, action.payload);

		const root = res?.data;
		const payload = root?.data ?? root;

		const items = normalizeRankData(payload?.items || payload || []);

		const total = typeof payload?.total === 'number' ? payload.total : items.length;

		yield put(rankingsSuccess({ items, total }));
	} catch (e: any) {
		yield put(
			rankingsFailure(e?.response?.data?.message || e?.message || 'Failed to load rankings'),
		);
	}
}

function* rankingsByPeriodWorker(action: ReturnType<typeof rankingsByPeriodRequest>) {
	try {
		const { period, _start = 0, _end = 50 } = action.payload;
		const { data } = yield call(getRankingsByPeriod, { period, _start, _end });
		console.log(data);

		const items = Array.isArray(data?.data?.items)
			? normalizeRankData(data?.data.items)
			: normalizeRankData(data?.items);
		console.log(items);

		yield put(rankingsByPeriodSuccess({ items, period }));
	} catch (e: any) {
		yield put(rankingsByPeriodFailure(e?.message || 'Failed to load rankings by period'));
	}
}

function* rankingsTournamentsWorker() {
	try {
		const { data } = yield call(getRankingsTournaments, {
			_start: 0,
			_end: 50,
		});
		console.log(data);
		const items = normalizeRankData(data?.items || data || []);
		console.log(items);
		yield put(
			rankingsTournamentsSuccess({
				items,
				total: data?.totalCount ?? items.length,
				endAt: data?.stats?.end_at ?? null,
				now: data?.stats?.now ?? null,
				reward: data?.stats?.reward ?? 0,
				personal: data?.personal ?? null,
			}),
		);
	} catch (e: any) {
		yield put(rankingsTournamentsFailure(e?.message || 'Failed to load tournament rankings'));
	}
}

export function* rankingsRootSaga() {
	yield takeLatest(rankingsRequest.type, rankingsWorker);
	yield takeLatest(rankingsByPeriodRequest.type, rankingsByPeriodWorker);
	yield takeLatest(rankingsTournamentsRequest.type, rankingsTournamentsWorker);
}
